import React from 'react';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { getQueryString } from '../../../utils/common';
import './index.scss';
const CopyrightAbout = props => {
	let history = useHistory();
	let title = decodeURIComponent(getQueryString('title') || '');
	return (
		<div className="copyright copyright-about">
			{/* // <!-- 头部导航栏 开始 --> */}
			<header className="nav-header-container">
				<div className="back">
					<span className="icon"></span>
					<label
						onClick={() => {
							history.goBack();
						}}>
						返回
					</label>
				</div>
				<span className="title">关于投图</span>
			</header>
			{/* // <!-- 头部导航栏 结束 -->
            // <!-- 正文内容 开始 --> */}
			<section className="main-content">
				<div className="set-details-container">
					<p>
						投图是中国首创专业的主题影像原创平台，也是一个可溯源的版权平台，由即时影像共享服务平台VPHOTO创建，以主题性征集形式，汇聚即时、热点、品质原创影像内容，为所有的影像爱好者提供优质原创图片/视频分享、版权维护等服务。
					</p>
					<p>目前，我们在全球拥有5000余位专业签约摄影师，每天有大量原创图片产出。摄影师们在这里可以拥有一个充分展示自己个性和优秀作品的专属主页，将你的作品分享。</p>
				</div>
			</section>
			{/* // <!-- 正文内容 结束 --> */}
		</div>
	);
};
export { CopyrightAbout };
